import { Box, Typography, Modal, Button } from '@mui/material';

import useStyles from './styles';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 480,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
};


const ToggleBanner = ({ open, handleClose, toggleNotificationBanner, bannerEnabled }) => {
    const classes = useStyles();

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} className={classes.notificationDeleteContainer}>
              
                <Typography id="modal-modal-titles" className={classes.deleteModalHeading}>
                  {bannerEnabled ? 'Are you sure you want to disable the banner for this notification?' : 'Are you sure you want to enable the banner for this notification?'}
                </Typography>

                <div className={classes.deleteButtonGroup}>
                    <Button variant='outlined' className={`${classes.notificationButton} ${classes.deleteButtonDimensions}`} onClick={handleClose}>Cancel</Button>
                    <Button variant="outlined" className={`${classes.notificationButton} ${classes.deleteButtonDimensions}`} onClick={toggleNotificationBanner}>Proceed</Button>
                </div>
            </Box>
        </Modal>
    );
};

export default ToggleBanner;